export const ANIMATION_LATENCY = 300;
export const MIN_FETCH_SYMBOLS_AMOUNT = 1;
export const SHOWING_CATEGORIES_AMOUNT = 5;
export const SHOWING_CATEGORIES_ENLARGED_AMOUNT = 10;
export const SHOWING_PRODUCTS_AMOUNT = 5;
export const SHOWING_ADVICES_AMOUNT = 5;
export const MAX_SEARCH_TERM_LENGTH = 128;
export const NOTHING_FOUND_ERROR_CODE = 'queryNotFound';
export const SHOW_LOADER_DELAY_THRESHOLD = 350;

export const MOCK_PRODUCTS = [
    {
        article: '137179',
        id: 1,
        images: [
            {
                alternative: 'Подпись к изображению',
                path: 'https://simplewine.ru/upload/iblock/03b/03b22ba989176f0f0c04bfa40bfcf587.png@x88?fmt=webp',
            },
        ],
        namePlates: [{}],
        price: {
            main: {
                basePrice: 1890,
                currency: 'RUB',
                discount: '-35%',
                price: '1229',
            },
        },
        rating: '4.7',
        title: 'Вино Герцъ, Сикоры, 2018 г.',
    },
    {
        article: '137179',
        id: 2,
        images: [
            {
                alternative: 'Подпись к изображению',
                path: 'https://simplewine.ru/upload/iblock/03b/03b22ba989176f0f0c04bfa40bfcf587.png@x88?fmt=webp',
            },
        ],
        namePlates: [{}],
        price: {
            main: {
                basePrice: 1890,
                currency: 'RUB',
            },
        },
        rating: '4.7',
        title: 'Игристое вино Prosecco Argeo Rose Brut Millesimato, Ruggeri, 2021 г.',
    },
    {
        article: '137179',
        id: 3,
        images: [
            {
                alternative: 'Подпись к изображению',
                path: 'https://simplewine.ru/upload/iblock/03b/03b22ba989176f0f0c04bfa40bfcf587.png@x88?fmt=webp',
            },
        ],
        namePlates: [{}],
        price: {
            main: {
                basePrice: 1890,
                currency: 'RUB',
            },
        },
        rating: '4.7',
        title: 'Игристое вино Prosecco Argeo',
    },
];
